import React from 'react'
import FilterComponent from './FilterComponent'
import { result } from 'libraries/lodash'
import cx from 'classnames'

export default class TextFilter extends FilterComponent {
  get value () {
    return result(this.props.filterValue, '0.value.0', '')
  }

  handleChange = (e) => {
    const value = e.target.value
    this.props.setFilterValue([
      [[value], '≈']
    ])
  }

  render () {
    const { basicDisplay } = this.props

    return (
      <div className='flex justify-end placeholder-cadet-blue-important w-100'>
        <input
          type='text'
          className={cx('pv2 ph3 bg-transparent ba mv2 mh0', {
            w13: basicDisplay,
            'w-100': !basicDisplay
          })}
          onChange={this.handleChange}
          value={this.value}
          placeholder='Search'
        />
      </div>
    )
  }
}
